import React from 'react';
import { useHistory } from 'react-router-dom';
import '../styles/About.css';
import { lang, getLang } from '../lang';

interface StickyNoteProps {
    text: string;
}

const StickyNote: React.FC<StickyNoteProps> = ({ text }) => {
    return (
        <div className="sticky-note">
            <div className="sticky-note-tape"></div>
            <p>{text}</p>
        </div>
    );
};

const routes = {
    es: {
        contact: '/contacto'
    },
    en: {
        contact: '/en/contact'
    }
};

const About: React.FC = () => {
    const history = useHistory();
    const currentLang = getLang();

    const handleContactanos = () => {
        history.push(routes[currentLang].contact);
        // Scroll to top after navigation
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    return (
        <section className="about-section">
            <div className="container about-content">
                <div className="about-header">
                    <h2 className="about-title">{lang.About.title}</h2>
                </div>
                <div className="about-description">
                    <p>
                    {lang.About.description}
                    </p>
                </div>
            </div>
            <div className="container sticky-notes-container">
                <StickyNote text={lang.About.stickyNotes[0]} />
                <StickyNote text={lang.About.stickyNotes[1]} />
                <StickyNote text={lang.About.stickyNotes[2]} />
                <StickyNote text={lang.About.stickyNotes[3]} />
            </div>
            <div className="contactanos-section">
                <button className="contactanos-button" onClick={handleContactanos}>
                    {lang.About.contactButton}
                </button>
            </div>
        </section>
    );
};

export default About; 